import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useCurrentUser } from '../../lib/session';
import { Rail } from '../inbox/Rail';
import styles from './Connections.module.css';

/** Pantallas de administración: la misma barra lateral y una columna de contenido. Solo ADMIN. */
export function AdminShell({ children }: { children: ReactNode }) {
  const user = useCurrentUser();
  if (user.role !== 'ADMIN') return <Navigate to="/" replace />;
  return (
    <div className={styles.app}>
      <Rail />
      <main className={styles.main}>
        <div className={styles.content}>{children}</div>
      </main>
    </div>
  );
}
